import {BgStyle, Color, Size, State} from '../types'
import {getColorVariant, getSizeVariant} from '../utils'

export const getSize = (size: Size): string => {
  const small = 'w-16 h-16'
  const medium = 'w-20 h-20'
  const big = 'w-24 h-24'

  return getSizeVariant(size, {small, medium, big})
}

export const getSvgSize = (size: Size): number => {
  const small = 16
  const medium = 20
  const big = 24

  return getSizeVariant(size, {small, medium, big})
}

export const getDefault = (color: Color): string => {
  const primary = 'text-action-default'
  const panelIconPrimary = 'text-panel-icon-primary'
  const secondary = 'text-grey'
  const panelIconSecondary = 'text-panel-icon-secondary'
  const error = 'text-error'
  const warning = 'text-warning'
  const grey = 'text-secondary'
  const invert = 'text-invert'

  return getColorVariant(color, {
    primary,
    panelIconPrimary,
    secondary,
    panelIconSecondary,
    error,
    warning,
    grey,
    invert
  })
}

export const getHover = (color: Color): string => {
  const primary = 'hover:text-action-hover'
  const panelIconPrimary = 'hover:text-action-hover'
  const secondary = 'hover:text-grey-l20'
  const panelIconSecondary = 'hover:text-action-hover'
  const error = 'hover:text-error-l20'
  const warning = 'hover:text-warning-l20'
  const grey = 'hover:text-action-hover'
  const invert = 'hover:text-interactive-l20'

  return getColorVariant(color, {
    primary,
    panelIconPrimary,
    secondary,
    panelIconSecondary,
    error,
    warning,
    grey,
    invert
  })
}

export const getActive = (color: Color): string => {
  const primary = 'active:text-action-pressed'
  const panelIconPrimary = 'active:text-action-pressed'
  const secondary = 'active:text-grey-d20'
  const panelIconSecondary = 'active:text-action-pressed'
  const error = 'active:text-error-d20'
  const warning = 'active:text-warning-d20'
  const grey = 'active:text-action-pressed'
  const invert = 'active:text-interactive-l80'

  return getColorVariant(color, {
    primary,
    panelIconPrimary,
    secondary,
    panelIconSecondary,
    error,
    warning,
    grey,
    invert
  })
}

export const getForced = (state: State, color: Color): string => {
  switch (state) {
    case 'default':
      return getColorVariant(color, {
        primary: '!text-action-default',
        panelIconPrimary: '!text-panel-icon-primary',
        secondary: '!text-grey',
        panelIconSecondary: '!text-panel-icon-secondary',
        error: '!text-error',
        warning: '!text-warning',
        grey: '!text-secondary',
        invert: '!text-invert'
      })
    case 'hover':
      return getColorVariant(color, {
        primary: '!text-action-hover',
        panelIconPrimary: '!text-action-hover',
        secondary: '!text-grey-l20',
        panelIconSecondary: '!text-action-hover',
        error: '!text-error-l20',
        warning: '!text-warning-l20',
        grey: '!text-action-hover',
        invert: '!text-interactive-d80'
      })
    case 'active':
      return getColorVariant(color, {
        primary: '!text-action-pressed',
        panelIconPrimary: '!text-action-pressed',
        secondary: '!text-grey-d20',
        panelIconSecondary: '!text-action-pressed',
        error: '!text-error-d20',
        warning: '!text-warning-d20',
        grey: '!text-action-pressed',
        invert: '!text-interactive-l80'
      })
  }
}

export const getBgHover = (bgStyle: BgStyle): string => {
  switch (bgStyle) {
    case 'message':
      return 'group-hover/icon-button:bg-reaction group-hover/icon-button:opacity-[0.15]'
    default:
      throw new Error(`Unknown bgStyle: ${bgStyle}`)
  }
}

export const getBgForced = (state: State, bgStyle: BgStyle): string => {
  switch (bgStyle) {
    case 'message':
      switch (state) {
        case 'hover':
        case 'active':
          return 'bg-reaction opacity-[0.15]'
        default:
          return ''
      }
    default:
      throw new Error(`Unknown bgStyle: ${bgStyle}`)
  }
}
